import React from "react";

export default function Footer() {
  return (
    <div>
      <footer className="footer">
        <p>Made at Ironhack, Miami © 2020</p>
      </footer>
    </div>
  );
}
